import UIComponent from '../../common/UIComponent';
import './index.css';
import markPoints from '../markpoints';
import Thumbnail from '../thumbnail';
import ProgressPointTime from '../pointTime';

export default class Progress extends UIComponent {
  constructor(elementId, interfaces, videoId, markPoints, AiHightlights) {
    super();
    this.markPoints = markPoints;
    this.AiHightlights = AiHightlights;
    this.interfaces = interfaces;

    this.elementId = elementId;
    this.videoNode = document.querySelector(`${videoId}`);
    this.thumbnail = null;
    this.pointTime = null;
    this.init();

    this.interfaces.on(VhallPlayer.LOADED, e => {
      this.progressContainer.setAttribute('class', 'vhallPlayer-progress-container display');
    });

    this.interfaces.on(VhallPlayer.TIMEUPDATE, () => {
      // TODO: 解决IOS上 IndexSizeError: The index is not in the allowed range.  报错
      if (this.interfaces.getBuffered().length <= 0) {
        return;
      }

      let progressLoadValue = 0;
      // FlashPlayer的buffered不支持end方法
      if (this.interfaces.vhallplayer.player._type === 'FlashPlayer') {
        const buffered = this.interfaces.getBuffered();
        progressLoadValue = (buffered[0][1] / this.interfaces.getDuration()) * 100;
      } else {
        progressLoadValue =
          (this.interfaces.getBuffered().end(this.interfaces.getBuffered().length - 1) /
            this.interfaces.getDuration()) *
          100;
      }
      this.progressLoad.style.width = progressLoadValue + '%';

      // seek状态时 不设置进度条的值
      if (this.isSeeking) {
        return;
      }

      const progressPlayValue = (this.interfaces.getCurrentTime() / this.interfaces.getDuration()) * 100;
      if (progressPlayValue > 100) {
        return;
      }
      this.progressPlay.style.width = progressPlayValue + '%';
      this.scrubber.style.left = progressPlayValue + '%';
    });
  }

  init() {
    this.progressContainer = document.createElement('div');
    this.progressContainer.setAttribute('class', 'vhallPlayer-progress-container hide');
    this.progressContainer.onmousedown = this.handleMouseDown.bind(this);
    // this.progressContainer.onmouseenter = this.onProgressMove.bind(this);
    // this.progressContainer.onmousemove = this.onProgressMove.bind(this);
    // this.progressContainer.onmouseleave = this.onProgressLeave.bind(this);

    this.progressLoad = document.createElement('div');
    this.progressLoad.setAttribute('class', 'vhallPlayer-progress-load');

    this.progressPlay = document.createElement('div');
    this.progressPlay.setAttribute('class', 'vhallPlayer-progress-play');

    this.scrubber = document.createElement('div');
    this.scrubber.setAttribute('class', 'vhallPlayer-progress-scrubber');
    // this.scrubber.innerHTML = `<i></i>`;

    var bar = document.createElement('i');
    this.scrubber.appendChild(bar);

    this.progressContainer.appendChild(this.progressLoad);
    this.progressContainer.appendChild(this.progressPlay);
    this.progressContainer.appendChild(this.scrubber);

    this.insertElement(this.elementId, this.progressContainer);

    // toDo add markdoms
    new markPoints('.vhallPlayer-progress-container', this.interfaces, this.markPoints, this.AiHightlights);

    // thumbnail
    // this.thumbnail = new Thumbnail(this.elementId, this.interfaces, {});
    // ProgressPointTime
    // this.pointTime = new ProgressPointTime(this.elementId, this.interfaces, {});
  }

  //动态更新预览雪碧图的位置与样式
  updateThumbnails(offsetX, progessWidth, now) {
    this.thumbnail && this.thumbnail.update(offsetX, progessWidth, now, 160, 90);
    this.thumbnail && this.thumbnail.show();
  }

  updatePointTime(offsetX, progessWidth, now) {
    if (this.thumbnail.usable) {
      return;
    }
    this.pointTime && this.pointTime.update(offsetX, progessWidth, now);
    this.pointTime && this.pointTime.show();
  }

  updatePosition(offsetX, progessWidth, now) {
    this.updateThumbnails(offsetX, progessWidth, now);
    this.updatePointTime(offsetX, progessWidth, now);
  }

  //鼠标进入进度条，或鼠标在进度条移动，则更新相关内容
  onProgressMove(event) {
    const duration = this.interfaces.getDuration();
    let now = (event.offsetX / this.progressContainer.offsetWidth) * duration;
    now = now < 0 ? 0 : now > duration ? duration : now;
    this.updatePosition(event.offsetX, this.progressContainer.offsetWidth, now);
  }

  //鼠标离开进度条，则隐藏雪碧图
  onProgressLeave(event) {
    this.thumbnail && this.thumbnail.hide();
  }

  handleMouseDown(event) {
    event.stopPropagation();
    event.preventDefault();
    this.isSeeking = true; // 按下鼠标时 则为正在seek
    const mouseX = event.clientX; // 鼠标按下时的位置
    let currentTime = null; // 当前播放时间值
    // 按下鼠标时计算当前播放值
    currentTime = (event.offsetX / this.progressContainer.offsetWidth) * this.interfaces.getDuration();
    // 设置圆点位置
    this.scrubber.style.left = (event.offsetX / this.progressContainer.offsetWidth) * 100 + '%';
    // 设置播放进度条宽度
    this.progressPlay.style.width = (event.offsetX / this.progressContainer.offsetWidth) * 100 + '%';
    // 重置预加载条
    this.progressLoad.style.width = 0 + '%';
    // 记录鼠标按下时距左距离
    let left = event.offsetX;

    document.onmousemove = event => {
      // 计算移动差值
      const moveL = event.clientX - mouseX;
      // 计算新的拖动位置
      const newW = moveL + left;
      // 计算拖动后的当前播放值
      currentTime = (newW / this.progressContainer.offsetWidth) * this.interfaces.getDuration();
      // 设置边缘值限制
      if (newW / this.progressContainer.offsetWidth < 0 || newW / this.progressContainer.offsetWidth > 1) {
        return;
      }
      // 设置圆点位置
      this.scrubber.style.left = (newW / this.progressContainer.offsetWidth) * 100 + '%';
      // 设置播放进度条宽度
      this.progressPlay.style.width = (newW / this.progressContainer.offsetWidth) * 100 + '%';
    };

    document.onmouseup = e => {
      // 鼠标抬起设置当前播放时间
      this.interfaces.setCurrentTime(currentTime);
      // 重置预加载条
      this.progressLoad.style.width = 0 + '%';
      // 关闭seek状态
      this.isSeeking = false;
      // 移除鼠标移动事件
      document.onmousemove = null;
      // 移除鼠标抬起事件
      document.onmouseup = null;
    };
  }
}
